import React from 'react';

import Appointment from './Appointment';
import Task from './Task';

export const Create = ({ activityType }) => activityType === 'TASK' ? <Task /> : <Appointment />;

export default Create;
